import { type PageViewport, type PDFPageProxy } from 'pdfjs-dist';

import { getRealPDFScale } from './getRealPDFScale';

export class PDFPagesViewportsCache {
  private readonly viewports = new Map<number, PageViewport>();

  getViewportForPage = (pageNumber: number) => this.viewports.get(pageNumber);

  generateViewportForPage = (pdfPage: PDFPageProxy, scale: number) => {
    const viewport = pdfPage.getViewport({ scale: getRealPDFScale(scale) });
    this.viewports.set(pdfPage.pageNumber, viewport);
  };
}
